import { CloseOutlined } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import useDrawer from 'hooks/useDrawer/useDrawer';
import useEnqueueSnackbar from 'hooks/useEnqueueSnackbar';
import useRestApiKey from 'hooks/useRestApiKey/useRestApiKey';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

interface Props {
  id: string;
  description: string;
  apiKey: string;
  handleClose: () => void;
}

const DeleteApiKey: React.FC<React.PropsWithChildren<Props>> = ({ id, description, apiKey, handleClose }) => {
  const { translation } = useTranslation();
  const enqueueSnackbar = useEnqueueSnackbar();
  const handleFetchError = (errorMessage: string) => enqueueSnackbar(errorMessage, { snackbartype: 'error' });
  const { deleteRestApiKey, deleteRestApiKeyLoading } = useRestApiKey({ handleFetchError });
  const { hideDrawer } = useDrawer();

  const handleDeleteKey = async () => {
    if (!deleteRestApiKeyLoading)
      try {
        await deleteRestApiKey(id);
      } finally {
        hideDrawer();
        handleClose();
      }
  };

  return (
    <Box
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#252525',
        border: '1px solid #444',
        borderRadius: '4px'
      }}
    >
      <ComponentWrapper width="35rem" flexDirection="column">
        <ComponentWrapper padding="1rem" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="textPrimary">
            {translation.delete_api_key}
          </Typography>
          <IconButton onClick={handleClose} style={{ padding: '4px' }}>
            <CloseOutlined style={{ color: 'rgba(255, 255, 255, 0.56)' }} />
          </IconButton>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="1.375rem 1.5rem" flexDirection="column">
          <Typography variant="body2" color="textPrimary">
            {translation.delete_api_key_confirmation}
            <br />
            <br />
          </Typography>
          <ComponentWrapper flexDirection="row" gap="0.5rem">
            <Typography variant="body2" color="textPrimary" style={{ fontWeight: 'bold' }}>
              {translation.name}:
              <br />
              {translation.reference}:
            </Typography>
            <Typography variant="body2" color="textPrimary">
              {description}
              <br />
              {apiKey}
            </Typography>
          </ComponentWrapper>
          <Typography variant="body2" color="textPrimary">
            <br />
            {translation.this_action_is_irreversible}
          </Typography>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="1rem" width="100%" justifyContent="end" alignItems="center" gap="1rem">
          <Button id="cancel-delete-api-key-button" size="medium" style={{ color: '#fff' }} onClick={handleClose}>
            {translation.cancel}
          </Button>
          <Button
            id="delete-api-key-button"
            size="medium"
            style={{ backgroundColor: '#FD3636', color: '#fff' }}
            onClick={handleDeleteKey}
          >
            {translation.delete}
          </Button>
        </ComponentWrapper>
      </ComponentWrapper>
    </Box>
  );
};

export default DeleteApiKey;
